<template>
  <div v-if="this.$get(this.$store, 'state.permissions.9.allow')">
    <div class="userconfig-container">
      <br />
      <div class="user-table-container">
        <b-list-group>
          <b-list-group-item v-for="(field, index) in fields" :key="index">
            <div class="d-flex w-100 justify-content-between informations-item-title" style="font-size:.5rem">
              <h5 class="mb-2">{{ field.label }}</h5>
            </div>
            <div>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'name'">
                <b-form-input type="text" :placeholder="field.label" v-model="user[field.key]"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'company_name'">
                <b-form-input type="text" :placeholder="field.label" v-model="user[field.key]"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'email'">
                <b-form-input type="text" :placeholder="field.label" v-model="user[field.key]"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'role_id'">
                <b-form-select :options="roles" value-field="id" text-field="desc" v-model="user[field.key]"
                  class="list-menu"></b-form-select>
              </p>

              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'password'">
                <b-form-input type="password" :placeholder="field.label" v-model="user[field.key]" />
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'password_confirm'">
                <b-form-input type="password" :placeholder="field.label" v-model="user[field.key]" />
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'status'">
                <b-form-select :options="[
                  { value: 0, text: 'Tidak Aktif' },
                  { value: 1, text: 'Aktif' },
                ]" v-model="user[field.key]" class="list-menu"></b-form-select>
              </p>
            </div>
          </b-list-group-item>
        </b-list-group>
        <div v-if="
          user.role_id == headHseRole() ||
          user.role_id == hseRole() ||
          user.role_id == kttRole()
        " style="padding: 10px">
          <div>Additional Roles for HSE & KTT</div>
          <div class="mb10">
            <treeselect :multiple="true" :options="gemsOptions" placeholder="Select Company..."
              v-model="gemsSelectValue" />
          </div>
        </div>
      </div>

      <div class="mt10">
        <b-button class="btn-edit mr-1" @click="cancelEdit">Cancel</b-button>
        <b-button class="btn-edit mr-1" @click="saveEdit">Save</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '../services/config'

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  name: 'adduser',
  components: {
    Treeselect,
  },
  data() {
    return {
      roles: [],
      fields: [
        { key: 'name', label: 'Name', type: 'text' },
        { key: 'company_name', label: 'Company Name', type: 'text' },
        { key: 'email', label: 'Email', type: 'text' },
        { key: 'role_id', label: 'Role', type: 'list' },
        { key: 'password', label: 'Password', type: 'password' },
        {
          key: 'password_confirm',
          label: 'Confirm Password',
          type: 'password',
        },
        { key: 'status', label: 'Status', type: 'list' },
      ],
      name: '',
      user: {
        name: null,
        company_name: null,
        email: null,
        role_id: null,
        status: 1,
        password: null,
        password_confirm: null,
      },
      gemsValue: null,
      gemsSelectValue: null,
      gemsOptions: [],
    }
  },
  async created() {
    await this.getUserRole()
    await this.getGemsCompanyCode()
  },
  methods: {
    headHseRole() {
      const roles = this.roles

      let hse = roles.filter(i => i.desc.toLowerCase() == 'head hse')

      if (hse.length > 0) {
        return hse[0].id
      }

      return 'wkwkwk'
    },
    hseRole() {
      const roles = this.roles

      let hse = roles.filter(i => i.desc.toLowerCase() == 'hse')

      if (hse.length > 0) {
        return hse[0].id
      }

      return 'wkwkwk'
    },
    kttRole() {
      const roles = this.roles

      let ktt = roles.filter(i => i.desc.toLowerCase() == 'ktt hse')

      if (ktt.length > 0) {
        return ktt[0].id
      }

      return 'wkwkwk'
    },
    cancelEdit() {
      this.$router.push({ path: '/user-role' })
    },
    checkForm(request) {
      let arr = [
        [this.user.name, 'Silahkan mengisi Nama User dengan benar.'],
        [
          this.isEmailValid(this.user.email),
          'Silahkan mengisi Email Vendor dengan benar.',
        ],
        [this.user.role_id, 'Silahkan mengisi User Role dengan benar.'],
        [this.user.password, 'Silahkan mengisi Password dengan benar'],
        [
          this.user.password_confirm,
          'Silahkan mengisi Confirm Password dengan benar.',
        ],
        [
          this.user.password == this.user.password_confirm,
          'Konfirmasi Password tidak sama.',
        ],
      ]

      return this.multiCustomConditions(arr)
    },
    async saveEdit() {
      let user = this.user;
      if (
        user.role_id == this.headHseRole() ||
        user.role_id == this.hseRole() ||
        user.role_id == this.kttRole()
      ) {
        user.companies = this.gemsSelectValue;
      }
      try {
        if (this.checkForm()) {
          const { data } = await axios({
            method: 'POST',
            url: `${api}/api/v1/user`,
            headers: {
              'Content-Type': 'application/json',
            },
            data: user,
          });
          if (data && data.status === 'success') {
            await this.$router.push({ path: '/user-role' });
            await this.$store.commit('SET_NOTIF', data.message);
          } else {
            await this.$store.commit('SET_NOTIF', data.message);
          }
        }
      } catch (error) {
        const errorMessage = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'An unknown error occurred';
        await this.$store.commit('SET_NOTIF', errorMessage);
      }
    },
    getData() {
      const self = this
      let id = this.$route.params.id
      axios({
        method: 'GET',
        url: `${api}/api/v1/user/user-by-id/${id}`,
      })
        .then(({ data }) => {
          self.user = {
            name: data.data.name,
            email: data.data.email,
            role_id: data.data.role_id,
            status: data.data.status,
          }
        })
        .catch(error => {
        })
    },
    getUserRole() {
      const self = this
      let id = this.$route.params.id
      axios({
        method: 'GET',
        url: `${api}/api/v1/user/roles`,
      })
        .then(({ data }) => {
          self.roles = data.data
        })
        .catch(error => {

        })
    },
    async getGemsCompanyCode() {
      try {
        const url = `${api}/api/v1/dashboard/company`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.gemsOptions = await data.data.map(item => {
            return {
              id: item.kode,
              label: `${item.kode} - ${item.nama_perusahaan}`,
            }
          })

          this.gemsOptions = await this.gemsOptions.filter(
            item => item.id != 2000
          )
        }
      } catch (error) {

      }
    },
    async getHSECompany() {
      try {
        const url = `${api}/api/v1/user/hse-company`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.gemsSelectValue = await data.data.map(item => {
            return item.kode
          })
        }
      } catch (error) {

      }
    },
  },
}
</script>
<style lang="scss">
@import '~/assets/scss/components/legaledit.scss';
</style>
